// extracted by mini-css-extract-plugin
module.exports = {"nameLink":"DemosTable_nameLink__3QOnd"};